<template>
  <div>
      <span class="release">{{ release.name }}</span>
      <br style="clear:both;" />
      <div>
        <span class="release-time">
          {{ release.start_time | fullDate }} -
          {{ release.end_time | fullTime }}
        </span>
        <h2>Time Slots</h2>
        <div
          v-for="timeslot in timeslots"
          :key="timeslot.id"
          class="time-slot"
          @click.self="toggleTimeslot(timeslot)"
          :style="
            timeslot.available_menu_items <= 0 && !timeslot.confirmationOpen
              ? disableTimeslot(timeslot)
              : ''
          "
        >
          {{ timeslot.start_time | fullTime }}
          {{ availableItemsCopy('slot', timeslot.available_menu_items) }}
          <div v-show="timeslot.visible">
            <OrderForm
              :pickupLocation="release.pickup_location"
              :menu_items="[{name: 'test', price: 0.99, item_type: 'merch'}]"
              :add_ons="release.add_ons"
              :merch="release.merches"
              :timeslot="timeslot"
              :releaseName="release.name"
              :minimumQuantity="0"
              :releaseType="'merch'"
              @order-submitted="orderSubmitted(timeslot, $event)"
              @decrement-quantity="decrementQuantity(timeslot, $event)"
            />
          </div>
        </div>
      </div>
  </div>
</template>

<script>
import moment from 'moment-timezone'
import OrderForm from '@/components/OrderForm.vue'

export default {
    components: {
        OrderForm
    },
    props: {
        release: Object,
        timeslots: Array
    },
    filters: {
      fullTime: function(date) {
        return moment(date).format('h:mma')
      },
      fullDate: function(date) {
        return moment(date).format('dddd, MMMM Do YYYY h:mma')
      }
    },
    methods: {
    availableItemsCopy: function(itemType, quantity) {
      if (quantity > 0) {
        return (
          quantity +
          ' ' +
          'order' +
          ' ' +
          this.pluralize(itemType, quantity) +
          ' ' +
          'available'
        )
      } else {
        return 'SOLD OUT!'
      }
    },
    decrementQuantity: function(timeslot, quantity) {
      timeslot.available_menu_items -= quantity
    },
    showDescriptionButtonPressed: function(release) {
      release.showDescription = !release.showDescription
    },
    disableTimeslot: function(timeslot) {
      return { 'pointer-events': 'none', opacity: 0.4 }
    },
    orderSubmitted: function(timeslot, quantity) {
    
      if (timeslot.available_menu_items == quantity) {
        timeslot.visible = !timeslot.visible
      }

      timeslot.available_menu_items -= quantity
    },
    toggleTimeslot: function(timeslot) {
      timeslot.confirmationOpen = false
      timeslot.visible = !timeslot.visible
    },

    pressedTimeslot: function() {
      confirm("Yes'm!")
    }
  }
}
</script>

<style>

</style>